<template>
	<div class="height-100dvh">
		<header class="mob-back-header header-z-index">
			<img
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Recent Interviews
		</header>
		<main class="become-panel-container app-bottom-padding mob-w100">
			<section class="mobir-sub-container">
				<RecentInterviewCard />
			</section>
		</main>
	</div>
</template>

<script>
import "@/assets/paneldashboard/paneldashboard.css";
import RecentInterviewCard from "@/components/PanelDasboard/RecentInterviewCard.vue";
export default {
	components: {
		RecentInterviewCard,
	},
};
</script>

<style>
.mobir-sub-container {
	background: #ffffff;
	border-radius: 4px;
	padding: 10px;
	height: 100%;
	overflow: auto;
}
@media (max-width: 1028px) {
	.pd-kanban-cards {
		height: 100%;
		display: flex;
		width: 100%;
		overflow-x: auto;
		gap: 15px;
		flex-direction: column;
	}
	.pd-kanban-cards .card {
		width: 100%;
	}
}
</style>
